var exports = {
  "H": "x9245d464--ad3671--preload-overlay",
  "R": "x9245d464--ad3671--preloader",
};

module.exports = exports;
